import {RealtimeEventType} from '@sollapay/enums';
import {useQueryClient} from '@tanstack/react-query';

import {trustAccountActivationKeys} from '@/features/trust-accounts/activation/hooks';
import {useRealtimeEvent} from '@/hooks/useRealtimeEvent';

import {showSupplementaryDeclarationRevokedToast} from '../components';

export function useFatcaCrsRealtimeUpdates(): void {
  const queryClient = useQueryClient();

  useRealtimeEvent(RealtimeEventType.SupplementaryDeclarationRevoked, event => {
    void queryClient.invalidateQueries({
      queryKey: trustAccountActivationKeys.compliancePackage(event.trustAccountId)
    });
    showSupplementaryDeclarationRevokedToast(
      event.trustAccountId,
      event.reason,
      event.trustPurpose
    );
  });
}
